import { IProductFilter, productFilterKeyType } from '../../constants/filter/productFilter.constant';

interface ICreateProductFilterSearchParamsParam {
  filters: IProductFilter[];
}

interface ICreateProductFilterSearchParamsReturn {
  category: string;
  status: string;
  brand: string;
  sort: string;
}

export const createProductFilterSearchParams = ({
  filters,
}: ICreateProductFilterSearchParamsParam): ICreateProductFilterSearchParamsReturn => {
  const getFilterOptionValues = (filterKey: productFilterKeyType) =>
    filters
      .find((filter) => filter.key === filterKey)
      ?.options.filter((option) => option.isSelected)
      .map((option) => option.value)
      .join(',');

  const categoryFilterOptionValues = getFilterOptionValues('filter_category');
  const statusFilterOptionValues = getFilterOptionValues('filter_status');
  const brandFilterOptionValues = getFilterOptionValues('filter_brand');
  const sorterFilterOptionValues = getFilterOptionValues('sorter');

  return {
    category: categoryFilterOptionValues ?? '',
    status: statusFilterOptionValues ?? '',
    brand: brandFilterOptionValues ?? '',
    sort: sorterFilterOptionValues ?? '',
  };
};
